module.exports = __webpack_public_path__ + "static/media/CV_UmayangaMadushan_v3.3.22c144f4.pdf";